import React, { useState, useEffect, useRef } from "react";
import styles from './index.pcss';
import classNames from "classnames/bind";
import BRTImageModule from "../../atoms/BraRecommendationToolImageGrid";
import { connect } from "react-redux";
import { dressToolCloseFlag, dressToolInitiateFinalFlag, dressToolInitiateInitialFlag, dressToolWithoutFirstStep, startAllSteps } from "../../../actions/shared/braRecommendation";
import properties from '../../../modules/ajio-util/properties';
import { redirect } from '../../utils/cartUtils';
import { getDressToolApiCall, getDressToolFlagData } from "../../selectors/braRecommedation";
import {
  hideModal as hideDressToolModal
} from '../../../actions/modal';
import { gtmDressToolInteractEvent,gtmDressToolViewEvent } from "../../../modules/ga/GTMdatalayer";

interface FinalPageDataInterface {
  applicable_style_name: string;
  applicable_style_image_url: string;
  applicable_style_desc: string;
  saas_redirection_params: string;
}
interface FinalPageData {
  data: FinalPageDataInterface[];
  triggerFlag: boolean;
  closeFlags: () => void;
  initiateInitialFlag: () => void;
  startAllSteps: () => void;
  isDeskTop?: boolean;
  initiateWithoutFirstFlag: () => void;
  hideDressModal: () => void;
  skipFirstStepFlag?: boolean;
  plpRedirectionUrl?: string;
  getApiCallData:any;
}

const BraRecommendationFinalContainer = ({ data, triggerFlag, closeFlags, initiateInitialFlag, startAllSteps, isDeskTop = false, initiateWithoutFirstFlag, skipFirstStepFlag, plpRedirectionUrl, hideDressModal, getApiCallData={} }: FinalPageData) => {
  const [flag, setFlag] = useState<boolean>(triggerFlag);
    const focusableRef = useRef<HTMLDivElement>(null);
  //const [flag, setFlag] = useState<boolean>(triggerFlag);
  const [selectedFinalStepGrid, setSelectedFinalStepGrid] = useState<Array<number>>([]);
  let urlSubPart = plpRedirectionUrl?.split(".com");
  const [finalRedirectionUrl, setFinalRedirectionUrl] = useState<string | undefined>(urlSubPart?.[1]);
  const [finalStylesName, setFinalStylesName] = useState<string>('');
  const [removedState, setRemovedState] = useState<boolean | number>();

  const noResultData = getApiCallData && getApiCallData?.no_result_screen;

  const imageBaseUrl: string = properties.getProperty('imageBaseUrl');

  let dressToolTriggerPoint = JSON.parse(sessionStorage.getItem('dressToolIngressDetails')) || '';
  useEffect(() => {
    if (triggerFlag) {
      document.body.classList.add(cx("body-no-scroll"));
      let ga4DressToolFireOnceEvent:string = '';
      const dressToolLocalFlag = localStorage?.getItem('ga4DressToolFireOnce');
      if(dressToolLocalFlag){
        ga4DressToolFireOnceEvent = JSON.parse(dressToolLocalFlag);
      }
      if(ga4DressToolFireOnceEvent === "final_step"){
        gtmDressToolViewEvent('page_view', {screenname: "dress tool style selection screen",dressToolTriggerPoint:dressToolTriggerPoint?.IngressPoint});
        localStorage.setItem('ga4DressToolFireOnce', JSON.stringify("end"));
      }
    } else {
      document.body.classList.remove(cx("body-no-scroll"));
    }

    return () => {
      document.body.classList.remove(cx("body-no-scroll"));
    };
  }, [flag]);

  useEffect(() => {
    setFlag(triggerFlag);
  }, [triggerFlag]);

  const cx = classNames.bind(styles);
  function handleSelectionFinalStepGrid(index: number): void {
    if (selectedFinalStepGrid && selectedFinalStepGrid.indexOf(index) !== -1) {                   //if any selected grid is unselected
      setSelectedFinalStepGrid((oldValues) => {
        return oldValues.filter((item) => item !== index);
      });
      setRemovedState(index);
    } else {                                                                                      //if any new grid is selected
      setSelectedFinalStepGrid((prevSelectedGrids) => [...prevSelectedGrids, index]);
      setRemovedState(false);
    }
  }

  function pdpRedirection(): void {
    gtmDressToolInteractEvent('dress_size_tool_interaction', {screenname: "dress tool style selection halfcard screen",dressToolTriggerPoint:dressToolTriggerPoint?.IngressPoint, category:"dress size tool interaction", action:"style_selected",label:(finalStylesName && finalStylesName.length>0 ? (finalStylesName?.endsWith(',') ? finalStylesName?.slice(0, -1) : finalStylesName) : '')});
    startAllSteps();                          //final redirection here
    closeFlags();
    if (isDeskTop) {
      hideDressModal("dress-tool-modal");
    }
    localStorage.setItem('ga4DressToolFireOnce', JSON.stringify("end"));
    window.location.href = selectedFinalStepGrid.length>0 ?  finalRedirectionUrl + '&dressTool=true' : "javascript: void(0)";
  }
  useEffect(() => {
    if (!isDeskTop && focusableRef.current) {
      const focusableElementsSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
      const modal = focusableRef.current;
      const focusableElements = modal.querySelectorAll<HTMLElement>(focusableElementsSelector);
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === "Tab") {
          if (e.shiftKey) {
            if (document.activeElement === firstElement) {
              e.preventDefault();
              lastElement.focus();
            }
          } else {
            if (document.activeElement === lastElement) {
              e.preventDefault();
              firstElement.focus();
            }
          }
        }
      };

      document.addEventListener("keydown", handleKeyDown);
      firstElement?.focus();

      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [isDeskTop, flag]); 

  useEffect(()=>{
    if((removedState || removedState===0) && typeof(removedState) === 'number'){                              //for removing deselected params from final redirection url
      let removeEncodedFilter = encodeURIComponent(data?.[removedState]?.saas_redirection_params);
      let tempFinalRedirectionUrl = finalRedirectionUrl?.replace(removeEncodedFilter,'');
      setFinalRedirectionUrl(tempFinalRedirectionUrl);

      let tempFinalSelectedStylesName = finalStylesName?.replace(data?.[removedState]?.applicable_style_name + ',','');    //for GA
      setFinalStylesName(tempFinalSelectedStylesName);
    }
    else if(removedState === false){                                                    //for adding deselected params from final redirection url
      let addEncodedFilter = encodeURIComponent(data?.[selectedFinalStepGrid?.slice(-1)[0]]?.saas_redirection_params);
      let tempFinalRedirectionUrl = finalRedirectionUrl + addEncodedFilter;
      setFinalRedirectionUrl(tempFinalRedirectionUrl);

      let tempFinalSelectedStylesName = finalStylesName + data?.[selectedFinalStepGrid?.slice(-1)[0]]?.applicable_style_name +',';    //for GA                                                                         //for GA
      setFinalStylesName(tempFinalSelectedStylesName);
    }
  },[selectedFinalStepGrid]);

  function retakeLogic(): void {
    if (skipFirstStepFlag) {                  //start from step 2 if 'withoutfirst' step is true after retake
      initiateWithoutFirstFlag();
      startAllSteps();
    }
    else {                                    //start from step 1 if 'withoutfirst' step is false after retake
      initiateInitialFlag();  
      startAllSteps();
    }
    setSelectedFinalStepGrid([]);
    setFinalRedirectionUrl(urlSubPart?.[1]);
    setFinalStylesName('');
    setRemovedState();
    gtmDressToolInteractEvent('dress_size_tool_interaction', {screenname: "dress tool style selection halfcard screen",dressToolTriggerPoint:dressToolTriggerPoint?.IngressPoint, category:"dress size tool interaction", action:"retake",label:"retake"});
  }

  function toolCloseFunctionality(): void {
    startAllSteps();
    closeFlags();
    localStorage.setItem('ga4DressToolFireOnce', JSON.stringify("end"));
  }


  return (
    <div>
      {!isDeskTop && <div className={cx('backdrop', { backdropVisible: flag })} />}
      <div className={isDeskTop ? '' : cx('BottomSheetContainer', { BottomSheetOpen: flag })}
        role={!isDeskTop ? "dialog" : undefined}
        aria-modal={!isDeskTop}
        {...(!isDeskTop && {'aria-labelledby':"bra-genie-header"})}
        ref={focusableRef}

      >
        {!isDeskTop && <div className={cx('headerSection')}>
          <button
            className={cx("bottomSheetCloseButton")}
            onClick={() => toolCloseFunctionality()}
            aria-label="Back"
          >
            <img
              alt=""
              aria-hidden="true"
              src={`${properties.getProperty(
                'imageBaseUrl'
              )}/static/img/back-arrow-refresh.svg`}
            />
          </button>
          <div className={cx("headerTitle")} role="heading" aria-level={1} id="bra-genie-header">AJIO Bra Genie</div>
        </div>}
        <div className={cx('titleSection')} role="heading" aria-level={2}>
          {data && data.length > 0 && <div className={isDeskTop ? cx("headingPartDesktop") : cx("headingPart")}>{getApiCallData && getApiCallData?.result_found_title ? getApiCallData?.result_found_title : "We've found the perfect bras for you! Choose the styles you’d like to explore."}</div>}
        </div>
        <div className={!isDeskTop ? cx("selectionGridContainerStep4"): ""}>
          <ul className={isDeskTop ? cx(data && data.length > 0 ? "desktopFinalGrid" : "desktopFinalGridEmpty") : cx("mobileFinalGrid")}>
            {data && data.length > 0 ? data?.map((item, index) => {
              return (
                <li
                  key={index}
                  onClick={() => { handleSelectionFinalStepGrid(index) }}
                  // tabIndex={0} Note: Causing li and checkboc read differently
                >
                  {!isDeskTop ? (
                     <div 
                        role="checkbox"
                        aria-checked={selectedFinalStepGrid && selectedFinalStepGrid.indexOf(index) !== -1}
                        aria-labelledby={`label-${item.applicable_style_name.replace(/\s+/g, '-')} label-${item.applicable_style_name.replace(/\s+/g, '-')}-2`}>
                          <BRTImageModule
                              imageLink={item.applicable_style_image_url}
                              imageName={item.applicable_style_name}
                              isSelected={selectedFinalStepGrid && selectedFinalStepGrid.indexOf(index) !== -1}
                              text={item.applicable_style_desc}
                              finalStep={true}
                              isDeskTop={isDeskTop}
                              onActivate={(e) => {
                                e.stopPropagation();
                                e.nativeEvent?.stopImmediatePropagation?.();
                                handleSelectionFinalStepGrid(index);
                              }}
                        />
                    </div>
                  ): (
                      <BRTImageModule
                      imageLink={item.applicable_style_image_url}
                      imageName={item.applicable_style_name}
                      isSelected={selectedFinalStepGrid && selectedFinalStepGrid.indexOf(index) !== -1}
                      text={item.applicable_style_desc}
                      finalStep={true}
                      isDeskTop={isDeskTop}
                      onActivate={(e) => {
                        e.stopPropagation();
                        e.nativeEvent?.stopImmediatePropagation?.();
                        handleSelectionFinalStepGrid(index);
                      }}
                    />
                  ) }
                  
                </li>
              );
            })
              : <div className={isDeskTop ? cx('emptyResultContainerDesktop') : cx('emptyResultContainer')}>
                <div className={isDeskTop ? cx('upperStaticSectionDesktop') : cx('upperStaticSection')}>
                  <div className={isDeskTop ? cx('upperContentSectionDesktop') : cx('upperContentSection')}>
                    <img
                      src={`${imageBaseUrl}/static/img/BraGenieImg.png`}
                      alt="Bra Genie Logo"
                      className={cx('braGenieImgLogo')}
                    />
                    <div className={cx('braGenieMainHeader')}>{noResultData && noResultData?.title ? noResultData?.title : "Oops! We couldn’t fetch the expected result."}
                    </div>
                    <div className={cx('braGenieSubHeader')}>{noResultData && noResultData?.subtitle ? noResultData?.subtitle : 
                      "You can still explore the app while we try to improve the results."}
                    </div>
                  </div>
                </div>
                <div className={cx('bottomButtonSection')}>
                  <div>
                    <button className={cx('braGenieContinueShopping')} onClick={redirect('/')}>
                    {noResultData && noResultData?.cta_text ? noResultData?.cta_text : "Continue Shopping"}
                    </button>
                  </div>
                </div>
              </div>
            }
          </ul>
          {data && data.length > 0 && flag && <div className={isDeskTop ? cx("buttonSectionDesktop") : cx("buttonSection")}>
            <div className={cx("retakeButton", { backButtonDesktop: isDeskTop })} onClick={() => retakeLogic()} role="button" tabIndex={0}>{getApiCallData && getApiCallData?.result_retake_cta_text ? getApiCallData?.result_retake_cta_text : "Retake"}</div>
              <button 
                title="acting as link"
                className={cx("nextButton", { [isDeskTop ? 'nextButtonActiveDesktop' : 'nextButtonActive']: selectedFinalStepGrid.length > 0, nextButtonDesktop: isDeskTop })} 
                disabled={selectedFinalStepGrid.length === 0} 
                onClick={() => pdpRedirection()} 
                aria-label={`${getApiCallData?.result_find_matching_cta_text || "Find matching bras"}${selectedFinalStepGrid.length === 0 ? ", disabled" : ""}`}
                tabIndex={selectedFinalStepGrid.length === 0 ? -1 : 0}
              >
                {getApiCallData && getApiCallData?.result_find_matching_cta_text ? getApiCallData?.result_find_matching_cta_text :"Find matching bras"}
              </button>
          </div>}
        </div>
      </div>
    </div>
  );
};


const mapDispatchToProps = (dispatch: any) => {
  return {
    initiateInitialFlag: () => dispatch(dressToolInitiateInitialFlag()),
    closeFlags: () => dispatch(dressToolCloseFlag()),
    startAllSteps: () => dispatch(startAllSteps()),
    initiateWithoutFirstFlag: () => dispatch(dressToolWithoutFirstStep()),
    hideDressModal: name => dispatch(hideDressToolModal(name))
  };
};

const mapStateToProps = (state: any) => {
  return {
    dressToolFlagReducer: getDressToolFlagData(state),
    getApiCallData: getDressToolApiCall(state),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BraRecommendationFinalContainer);
